const formValidation = [
  {
    fieldName: 'isPep',
    fieldNick: 'Politicamente Expuesto',
    isValid: val => {
      return val ? (val !== undefined && typeof val === 'number' && val > 0) : false
    }
  }
]

const pepOptions = [
  {label: 'Sí', value: 1},
  {label: 'No', value: 2}
]

export {
  formValidation,
  pepOptions
}
